import evmLib from './evmLib';

const {
  SERVER,
  CHAIN_ID
} = require('./config');

const ethers = require("ethers").ethers;
const moment = require('moment');
const io = require('socket.io-client');
const feathers = require('@feathersjs/client');

const socket = io(SERVER);
const client = feathers();

client.configure(feathers.socketio(socket, {
  timeout: 180000
}));
client.configure(feathers.authentication());

const swapDataService = client.service('swap-data');
const sessionDataService = client.service('session-data');

async function getPublicData() {
  let sd = await swapDataService.find({ query: { $limit: 0 } });
  sd = await swapDataService.find({
    query: {
      chainId: CHAIN_ID,
      $limit: sd.total,
      $sort: {
        ts: -1
      }
    }
  });

  let sddata = [];
  let skip = 0;
  while (sddata.length < sd.total) {
    const result = await swapDataService.find({
      query: {
        chainId: CHAIN_ID,
        $limit: 10,
        $skip: skip,
        $sort: {
          ts: -1
        }
      }
    });

    sddata = sddata.concat(result.data);
    skip += 10;
  }

  const tsNow = moment().unix();
  const tsd1 = tsNow - (3600 * 24);
  const tsd7 = tsNow - (3600 * 24 * 7);
  const tsd30 = tsNow - (3600 * 24 * 30);
  const tsd365 = tsNow - (3600 * 24 * 365);

  let currentPrice = ethers.BigNumber.from(0);
  if (sd.total > 0) currentPrice = ethers.BigNumber.from(sd.data[0].price);
  let ath = ethers.BigNumber.from(currentPrice);
  let atl = ethers.BigNumber.from(currentPrice);
  let priced1 = false;
  let priced7 = false;
  let priced30 = false;
  let priced365 = false;
  // const sddata = sd.data;
  for (let i = 0; i < sddata.length; i++) {
    const row = sddata[i];
    const price = ethers.BigNumber.from(row.price);
    const ts = row.ts;
    if (price.gt(ath)) ath = price;
    if (price.lt(atl)) atl = price;
    if (!priced1 && ts <= tsd1) priced1 = price;
    if (!priced7 && ts <= tsd7) priced7 = price;
    if (!priced30 && ts <= tsd30) priced30 = price;
    if (!priced365 && ts <= tsd365) priced365 = price;
  }


  function calcPctg(startP, endP) {
    if (startP.gt(0)) {
      let pctg = (endP.sub(startP)).mul(100).div(startP);
      return pctg.toNumber();
    }
    return 0;
  }

  const pctg1 = priced1 ? calcPctg(priced1, currentPrice) : '-';
  const pctg7 = priced7 ? calcPctg(priced7, currentPrice) : '-';
  const pctg30 = priced30 ? calcPctg(priced30, currentPrice) : '-';
  const pctg365 = priced365 ? calcPctg(priced365, currentPrice) : '-';

  const athPctg = calcPctg(ath, currentPrice);
  const atlPctg = calcPctg(atl, currentPrice);

  let ssd = await sessionDataService.find({ query: { chainId: CHAIN_ID } });
  let sessions = [];
  let avgProfitPerShare = false;

  let ssData = {};

  if (ssd.total > 0) {
    ssData = ssd.data[0];
    const history = ssd.data[0].history

    const divider = history.length;
    let total = ethers.BigNumber.from(0);

    for (let i = 0; i < history.length; i++) {
      const h = history[i];

      sessions.unshift({
        turn: h.turn,
        session: moment.unix(h.createdAt).format('YYYY/MM/DD HH:mm'),
        generated: evmLib.wei2eth(h.totalGenerated),
        totalShare: h.totalShare,
        generatedPerShare: evmLib.wei2eth(h.profitPerShare),
      });

      total = total.add(h.profitPerShare);
    }

    avgProfitPerShare = divider > 0 ? evmLib.wei2eth(total.div(divider)) : 0.0;

    sessions.unshift({
      turn: ssd.data[0].currentTurn,
      session: 'On Going',
      generated: '-',
      totalShare: ssd.data[0].currentTotalShare,
      generatedPerShare: '-'
    })
  }

  const ret = {
    currentPrice: evmLib.wei2eth(currentPrice.toString()),
    athPrice: evmLib.wei2eth(ath.toString()),
    atlPrice: evmLib.wei2eth(atl.toString()),
    pctg1,
    pctg7,
    pctg30,
    pctg365,
    athPctg,
    atlPctg,
    sessions,
    avgProfitPerShare,
    nftMinted: ssData.nftMinted,
    nftGenerated: evmLib.wei2eth(ssData.nftGenerated)
  };


  return ret;
}

export default {
  // module.exports = {
  swapDataService,
  getPublicData
};

